class Model {//
}

export { Model };
//# sourceMappingURL=Model.mjs.map
